import { Calculator, Fire } from "@phosphor-icons/react";
import { ACTIVITY_MULTIPLIERS } from "@/lib/tdee";

const CALORIC_OPTIONS = ["ipocalorica", "normocalorica", "ipercalorica"];
const COLORS = {
  ipocalorica: { border: "border-red-500/30", text: "text-red-400", activeBg: "bg-red-500/25" },
  normocalorica: { border: "border-[#D4FF00]/30", text: "text-[#D4FF00]", activeBg: "bg-[#D4FF00]/20" },
  ipercalorica: { border: "border-green-500/30", text: "text-green-400", activeBg: "bg-green-500/25" },
};

export default function TDEECalculator({
  tdeeData,
  activityLevel,
  caloricStatus,
  onCaloricStatusChange,
}) {
  return (
    <div className="mb-6 p-4 rounded-lg border border-[#262626] bg-[#0F0F0F]" data-testid="tdee-calculator">
      <div className="flex items-center gap-2 mb-3">
        <Calculator size={18} weight="duotone" className="text-[#007AFF]" />
        <span className="text-xs font-bold uppercase tracking-[0.15em] text-zinc-400">
          Calcolatore TDEE (Mifflin-St Jeor)
        </span>
      </div>
      {tdeeData ? (
        <div className="grid grid-cols-1 sm:grid-cols-4 gap-3">
          <div className="bg-[#171717] rounded-lg p-3 border border-[#1E1E1E]">
            <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-600 mb-1">BMR</p>
            <p className="text-2xl font-black text-white" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>
              {tdeeData.bmr}
            </p>
            <p className="text-[10px] text-zinc-600">kcal/giorno a riposo</p>
          </div>
          <div className="bg-[#171717] rounded-lg p-3 border border-[#007AFF]/20">
            <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#007AFF] mb-1">TDEE</p>
            <p className="text-2xl font-black text-[#007AFF]" style={{ fontFamily: "Barlow Condensed, sans-serif" }}>
              {tdeeData.tdee}
            </p>
            <p className="text-[10px] text-zinc-500">
              kcal/giorno ({ACTIVITY_MULTIPLIERS[activityLevel]?.desc})
            </p>
          </div>
          <div className="bg-[#171717] rounded-lg p-3 border border-[#1E1E1E]">
            <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-600 mb-1">
              OBIETTIVI CALORICI
            </p>
            <div className="space-y-1">
              <div className="flex justify-between text-xs">
                <span className="text-zinc-500">Deficit (-10%)</span>
                <span className="text-red-400 font-bold">{Math.round(tdeeData.tdee * 0.9)}</span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-zinc-500">Mantenimento</span>
                <span className="text-[#D4FF00] font-bold">{tdeeData.tdee}</span>
              </div>
              <div className="flex justify-between text-xs">
                <span className="text-zinc-500">Surplus (+10%)</span>
                <span className="text-green-400 font-bold">{Math.round(tdeeData.tdee * 1.1)}</span>
              </div>
            </div>
          </div>
          <div className="bg-[#171717] rounded-lg p-3 border border-[#1E1E1E]">
            <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-zinc-600 mb-2">STATO ATTUALE</p>
            <div className="space-y-1.5">
              {CALORIC_OPTIONS.map((opt) => {
                const isSelected = caloricStatus === opt;
                const c = COLORS[opt];
                return (
                  <button
                    key={opt}
                    onClick={() => onCaloricStatusChange(isSelected ? "" : opt)}
                    className={`w-full px-3 py-1.5 rounded-md text-xs font-semibold capitalize border transition-all ${
                      isSelected
                        ? `${c.activeBg} ${c.border} ${c.text}`
                        : "bg-transparent border-[#262626] text-zinc-500 hover:border-[#333] hover:text-zinc-300"
                    }`}
                    data-testid={`caloric-status-${opt}`}
                  >
                    {opt}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      ) : (
        <div className="flex items-center gap-2 text-zinc-600 text-sm py-2">
          <Fire size={16} />
          <span>
            Compila peso, altezza, data di nascita, sesso e livello attivita per calcolare il TDEE
          </span>
        </div>
      )}
    </div>
  );
}
